document.addEventListener('DOMContentLoaded', function () {
    const physicalFormLogic = window.initRegistrationForm('registraion-physical-form');

    if (!physicalFormLogic) return;

    const formElement = document.getElementById('registraion-physical-form');

    formElement.addEventListener('submit', function (e) {
        const isValid = physicalFormLogic.validateBaseFields();
        if (!isValid) {
            e.preventDefault();
        }
    });
});
